const base64ToBlob = (base64: string, mime: string) => {
  const byteCharacters = window.atob(base64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  return new Blob([byteArray], { type: mime })
}

export const saveBase64asFile = (base64Data: string, filename: string, type: string) => {
  const blob = base64ToBlob(base64Data, type)

  const a = document.createElement('a')
  a.style.display = 'none'
  document.body.appendChild(a)
  const url = window.URL.createObjectURL(blob)
  a.href = url
  a.download = filename
  a.click()

  // immediate cleanup breaks downloads of large files for that reason defer cleanup
  setTimeout(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }, 0)
}

export const saveBase64AsCSV = (data: string, filename: string) => {
  saveBase64asFile(data, filename, 'text/csv')
}

export const saveBase64AsWordFile = (data: string, filename: string) => {
  saveBase64asFile(data, filename, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
}

export const saveBase64AsExcelFile = (data: string, filename: string) => {
  saveBase64asFile(data, filename, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
}

export const saveBase64AsPDF = (data: string, filename: string) => {
  saveBase64asFile(data, filename, 'application/pdf')
}
